import React, { useRef, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Moment from 'moment';
import { projectsApi } from '../../../utils'
import useClickOutside from '../../../hooks/useClickOutside';
import Project from '../../lms-shared/UI/Project'
import openNewProj from '../../../assests/dashboard/projects/open-new-proj.png'
import newProj from '../../../assests/dashboard/projects/new-proj.png'
import openImportOldProj from '../../../assests/dashboard/projects/open-import-old-proj.png'
import importOldProj from '../../../assests/dashboard/projects/import-old-proj.png'
import SandBoxIcon from '../../../assests/dashboard/projects/sandBox.png'
import LearningAssessmentsIcon from '../../../assests/dashboard/projects/learningAssessments.png'
import SubmissionTasksIcon from '../../../assests/dashboard/projects/submissionTasks.png'
import classes from './Projects.module.css'
import NewProject from "./NewProject";
import HeaderActionBar from "../Dashboard/HeaderActionBar/HeaderActionBar";
import { FilterTypesEnum } from '../../UI/Filter';
import { ObjectTypeEnum, ObjectTypeEnumText } from "../../../models/ObjectTypeEnum";
import ImportOldProjects from "./ImportOldProjects";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import ShareProjectBtn from "../../UI/ShareProjectBtn";
import { useNavigate, useSearchParams } from "react-router-dom";
import { onKeyDown } from "../../../service";
import LessonsBtnMenu from "../Dashboard/Lessons/LessonsBtnMenu";
import { ActivityTypeEnum, ActivityTypeEnumText } from "../../lms-shared/models/ActivityTypeEnum";


var HALF_HOUR = 60 * 30 * 1000; /* ms */

const Projects = ({ isPopup, chosenProjectCallback }) => {

    const { direction, texts } = useSelector((state) => state.translate);
    const { homeUrl, importOldProjects } = useSelector(state => state.application);
    const { user } = useSelector(state => state.auth);
    const studyGroup = useSelector(state => state.topics.studyGroup);
    const [messagePopup, setMessagePopup] = useState()
    const [projects, setProjects] = useState()
    const [filteredProjects, setFilteredProjects] = useState()
    const [showOpenNewProject, setShowOpenNewProject] = useState(false)
    const [showImportOldProjects, setShowImportOldProjects] = useState(false)
    const [currentIdToEdit, setCurrentIdToEdit] = useState(false)
    const [currentChosen, setCurrentChosen] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams();
    const projectTypeParam = searchParams.get('projectType');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [projectType, setProjectType] = useState(0)
    const btnList = useMemo(() => [{ text: texts.submissionTasksTitle, icon: SubmissionTasksIcon, refObjectType: ObjectTypeEnum.Submission, assessmentActivityType: ActivityTypeEnum.Final },
    { text: texts.learningAssessments, icon: LearningAssessmentsIcon, refObjectType: ObjectTypeEnum.Submission, assessmentActivityType: ActivityTypeEnum.Learning },
    { text: texts.DraftScreen, icon: SandBoxIcon, refObjectType: ObjectTypeEnum.StudyGroup }], [])

    useEffect(() => {
        if (projectTypeParam) {
            setProjectType(parseInt(projectTypeParam));
        }
    }, [projectTypeParam]);

    const handleProjectTypeChange = (newProjectType) => {
        setProjectType(newProjectType);
        setSearchParams({ ...Object.fromEntries(searchParams.entries()), projectType: newProjectType });
    };

    async function getData() {

        const getObjectTypeName = (type) => {
            const entry = Object.entries(ObjectTypeEnum).find(([key, value]) => value === type);
            return entry ? ObjectTypeEnumText[entry[0]] : null;
        }

        const getAssessmentActivityTypeName = (type) => {
            const entry = Object.entries(ActivityTypeEnum).find(([key, value]) => value === type);
            return entry ? ActivityTypeEnumText[entry[0]] : null;
        }

        const data = {
            onlyDrafts: true,
            refObjectType: getObjectTypeName(btnList[projectType].refObjectType),
            refObjectId: studyGroup.id,
            includeIsShared: !isPopup,
            ...(getAssessmentActivityTypeName(btnList[projectType].assessmentActivityType) && {
                assessmentActivityType: getAssessmentActivityTypeName(btnList[projectType].assessmentActivityType)
            })
        };
        projectsApi.projectsFilterRangePost({ projectsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.projectsFilterError, error: error, statusCode: response?.statusCode, message: "projectsFilterRangePost " + error.message, level: 2, component: "Projects", line: 53 }))
            } else {
                resdata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
                setProjects(resdata)
                setFilteredProjects(resdata)
            }
        })
    }

    useEffect(() => {
        if (studyGroup && studyGroup.id) {
            getData()
        }
    }, [studyGroup, projectType])

    useEffect(() => {
        if (isPopup) {
            handleProjectTypeChange(1)
        }
    }, [isPopup])

    function openProject(project) {
        if (studyGroup) {
            navigate(`${homeUrl}/${studyGroup.id}/project/${project.id}`, { state: { prevPath: window.location.pathname, replace: true } })
        }

    }

    function editProjectName(projectId, newName) {
        if (newName && newName !== '') {
            const data = {
                id: projectId,
                name: newName
            }
            projectsApi.projectsUpdatePost({ "projectUpdateInput": data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.projectsUpdateError, error: error, statusCode: response?.statusCode, message: "projectsUpdatePost " + error.message, level: 2, component: "Projects", line: 83 }))
                } else {
                    getData()
                }
            })
        }
    }

    function handleChangeCurrentIdToEdit(e, p) {
        e.stopPropagation();
        setCurrentIdToEdit(p.id)
    }

    function openNewProjectPopup(e) {
        e.stopPropagation();
        setShowOpenNewProject(true)
    }

    function CloseNewProjectPopup(e) {
        e.stopPropagation();
        setShowOpenNewProject(false)
    }

    function openImportOldPopup(e) {
        e.stopPropagation();
        setShowImportOldProjects(true)
    }

    function closeImportOldPopup(e) {
        e.stopPropagation();
        setShowImportOldProjects(false)
        getData()
    }

    function addNewProject() {
        setShowOpenNewProject(false)
        getData()
    }

    // function handleClickOnProject(isDoubleClick, p) {
    //     if (!isDoubleClick) {
    //         setCurrentChosen(p.id)
    //     } else {
    //         isPopup && isDoubleClick && chosenProjectCallback(p)
    //     }
    // }

    function handleClickOnProject(p) {
        setCurrentChosen(p)
    }

    function changeProject() {
        currentChosen && chosenProjectCallback(currentChosen)
    }

    const newProjectPopupRef = useRef(null);
    useClickOutside(newProjectPopupRef, () => {
        setShowOpenNewProject(false)
    });

    const importOldProjPopupRef = useRef(null);
    useClickOutside(importOldProjPopupRef, () => {
        setShowImportOldProjects(false)
    });

    const filter = (inputs) => {
        const list = projects && projects.filter(p =>
            Object.keys(inputs).map(key => {
                if (key === "free") {
                    if (!inputs[key] || (inputs[key] && ["name"].some(field => p[field] && p[field].includes && p[field].includes(inputs[key]))))
                        return true;
                    else
                        return false
                } else {
                    if (key = "ide") {
                        if (inputs[key].length == 0 || inputs[key].includes(p[key].id)) {
                            return true;
                        }
                        else
                            return false;
                    }
                    else {
                        if (inputs[key].length == 0 || inputs[key].includes(p[key])) {
                            return true;
                        }
                        else
                            return false;
                    }

                }
            }).every(p => p === true)
        )
        setFilteredProjects(list)
    }

    return (
        <div className={classes.Projects} style={{ marginInlineRight: isPopup ? "" : "21px" }}>
            {messagePopup}
            {!isPopup && <>
                <HeaderActionBar
                    filtercb={filter}
                    filters={[{ text: texts.freeFilter, name: "free", type: FilterTypesEnum.free },
                    { text: texts.ideFilter, values: [1, 2, 3], name: "ide", type: FilterTypesEnum.values }]}
                >
                </HeaderActionBar>
                <div className={classes.Header}>
                    <div className={classes.TitleWrapper}>
                        <h1 className={classes.Title}>{texts.projects}</h1>
                        {studyGroup && studyGroup.courseName && studyGroup.name && <h2 className={classes.CourseNameMap}><span className={classes.MyLessonsText}>{studyGroup.courseName} | </span>{studyGroup.name}</h2>}
                    </div>
                    {btnList[projectType].refObjectType === ObjectTypeEnum.StudyGroup ? <div className={classes.Actions}>
                        <div className={classes.newProj} ref={newProjectPopupRef} onClick={openNewProjectPopup} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openNewProjectPopup)} style={{ backgroundColor: showOpenNewProject ? "#FFF" : "" }}>
                            <div className={`${classes.NewProjText} ${classes.Text}`}>{texts.createNew}</div>
                            {showOpenNewProject && studyGroup ?
                                <>
                                    <img className={classes.newProjIcon} src={newProj} alt="NewProjectIcon" />
                                    <NewProject studyGroupId={studyGroup.id} closePopup={CloseNewProjectPopup} addNewProject={addNewProject} />
                                </>
                                :
                                <img className={classes.newProjIcon} src={openNewProj} alt="NewProjectIcon" />
                            }
                        </div>
                        {importOldProjects && 
                            <div className={classes.ImportOldProj} ref={importOldProjPopupRef} onClick={openImportOldPopup} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openImportOldPopup)} style={{ backgroundColor: showImportOldProjects ? "#FFF" : "" }}>
                                <div className={`${classes.ImportOldProjText} ${classes.Text}`}>{texts.importProjectsFromLastYear}</div>
                                {showImportOldProjects && studyGroup ?
                                    <>
                                        <img className={classes.newProjIcon} src={importOldProj} alt="ImportOldProjectIcon" />
                                        <ImportOldProjects studyGroupId={studyGroup.id} closePopup={closeImportOldPopup} />
                                    </>
                                    :
                                    <img className={classes.ImportOldProjIcon} src={openImportOldProj} alt="ImportOldProjectIcon" />
                                }
                            </div>
                        }
                    </div> : ''}
                </div>
            </>}
            <div className={`${classes.ProjectsWithTabs} ${isPopup ? classes.ProjectsWithTabsFromPopup : ''}`}>
                {isPopup ? '' :
                    <div className={classes.TabsContainer}>
                        <LessonsBtnMenu btnList={btnList} currentBtn={projectType} changeBtn={(newCurrentBtn) => handleProjectTypeChange(newCurrentBtn)} HiddenText={true} />
                    </div>}
                <div className={`${classes[direction]} ${classes.ProjectsContentWrapper} ${isPopup && classes.ProjectsContentWrapperPopup}`}>
                    <div className={classes.TypeTitle}>{btnList[projectType].text}</div>
                    <div className={classes.ProjectsContent}>
                        {filteredProjects && filteredProjects.length > 0 ? [].concat(filteredProjects)
                            .sort((a, b) => a.lastCreatedHistoryDate < b.lastCreatedHistoryDate ? 1 : -1).map(p =>
                                <div className={`${classes.Project} ${isPopup && p === currentChosen && classes.Chosen}`} key={p.id}>
                                    <Project
                                        project={p}
                                        descriptionDate={((new Date) - p.createdDate) < HALF_HOUR ? `${texts.new}` : Moment(p.createdDate).format('DD/MM/YY | HH:mm')}
                                        openProject={() => !isPopup && openProject(p)}
                                        selectProject={() => handleClickOnProject(p)}
                                        // selectProject={(isDoubleClick) => handleClickOnProject(isDoubleClick, p)}
                                        canDelete={true}
                                        actionCallback={getData}
                                        handleChangeCurrentIdToEdit={handleChangeCurrentIdToEdit}
                                        currentIdToEdit={currentIdToEdit}
                                        setCurrentIdToEdit={setCurrentIdToEdit}
                                        editProjectName={editProjectName}
                                        noEditName={isPopup}
                                        showFunc={!isPopup}
                                        shareBtn={ShareProjectBtn}
                                        canSend={true}

                                    />
                                </div>
                            ) :
                            isPopup && <div className={classes.NoProjects}>{texts.noProjects}</div>}
                    </div>
                    {isPopup &&
                        <div className={classes.ChangeBtn} onClick={changeProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, changeProject)} style={{ cursor: currentChosen ? "pointer" : "not-allowed" }}>
                            {texts.change}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default Projects